import { WatchListActionTypes, WatchListActions } from '../actions/watchlist.actions'
import { WatchListItemNew } from '../models/watch-list.model'
import { createSelector } from '@ngrx/store';
import { AppState } from './index';

export interface WatchListState {
    loadError: string,
    loaded: boolean,
    products: WatchListItemNew[]
}

export const initialState: WatchListState = {
    loadError: null,
    loaded: false,
    products: [],
};

export function watchListReducer(
    state = initialState,
    action: WatchListActions
): WatchListState {
    switch (action.type) {
        case WatchListActionTypes.DeleteSuccess:
            return {
                ...state,
                products: state.products.filter((val) => {
                    return val.out_stock_code !== action.payload;
                })
            };
        case WatchListActionTypes.DeleteFailure:
            return {
                ...state
            };
        case WatchListActionTypes.LoadSuccess:
            return {
                ...state,
                loaded: true,
                products: action.payload
            };
        case WatchListActionTypes.LoadFailure:
            return {
                products: [],
                loaded: false,
                loadError: action.payload
            };
        case WatchListActionTypes.InsertSuccess:

            return {
                ...state,
                products: state.products.concat(action.payload)
            };
        case WatchListActionTypes.InsertFailure:
            return {
                ...state
            }
        default:
            return {
                ...state
            }
    }
}

export const selectWatchListFeature = (state: AppState) => state.watchListState;

export const getWatchListStateLoaded = createSelector(
    selectWatchListFeature,
    (state: WatchListState) => state.loaded)

export const getWatchListStateProducts = createSelector(
    selectWatchListFeature,
    (state: WatchListState) => state.products)